import { render, staticRenderFns } from "./CerrarSesionDialog.vue?vue&type=template&id=0be3e858"
import script from "./CerrarSesionDialog.vue?vue&type=script&lang=js"
export * from "./CerrarSesionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports